export const notice = [
  {
    href: "/jp/ja/notice/1021041",
    text: "台風4号による配送への影響について",
  },
];